import {Button, FlipList, Icon, Link} from '@startlibs/components';
import React from 'react'

import {
  PatientName,
  ProgressBar,
  RecordDescription,
  RecordItem,
  RecordItemStyled, UploadedIcon,
  UploadStatus,
  DicomIcon, RemoveRecordIcon
} from '../panel/RecordItem'
import {RecordStatus} from '../lib/utils/recordEnums'
import {UploaderAction} from '../lib/service'
import {WidgetBody} from '../panel/PanelStyles'
import styled, {css} from 'styled-components'
import {dicomDateToDate} from '../../utils'
import {formatDate, getColor, media} from '@startlibs/utils'
import {dateMessages} from '../lib/utils/dateMessages'
import {useToggle} from '@startlibs/core'
import {lighten} from 'polished'

export const RecordList = ({records,uploadLogDialog, canRemove,doAction}) => {

  return <FlipList>
    {records.map(record => <PageRecordItem canRemove={canRemove} openLog={() => {
      uploadLogDialog.openWith({filter:(allFiles) => {
          const recordFiles =  doAction(UploaderAction.GetFilesForRecord,record.key)
          return allFiles.filter(({file}) => recordFiles.includes(file))
        }})
    }} doAction={doAction} record={record}/>)}
  </FlipList>

}

const RecordStatusContainer = styled.div`
  flex-basis: 17rem;
  flex-shrink: 0;
  ${media.desktop`
    margin-left: 1rem;
  `}
  ${media.mobile`
    margin-top: 1rem;
  `}
`

const RemoveConfirmation = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  min-height: 100%;
  background: ${props => lighten(0.5, getColor("alert")(props))};
  padding: 1.5rem;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
`

const PageRecordItem = ({openLog,record,doAction, canRemove}) => {
  const canceling = useToggle()

  return <RecordItemStyled>
    <DicomIcon/>
    <div>
      <PatientName>{record.patientName}</PatientName>
      {canRemove && <RemoveRecordIcon onClick={(record.fileProgress.uploaded + record.fileProgress.failed) !== record.fileProgress.total ? canceling.open : (() => doAction(UploaderAction.Delete,record))}/>}
      <RecordDescription><b>DoB:</b> {record.patientDoB ? formatDate(dicomDateToDate(record.patientDoB), 'yyyy-MM-dd', dateMessages, true) : "Not available"} / <b>Sex:</b> {record.patientSex || "Not available"}</RecordDescription>
      <RecordDescription><b>Study Description:</b> {record.studyModalities?.join(", ")}{record.studyModalities && " - "}{record.name}</RecordDescription>
      <RecordDescription><b>Study Date:</b> {record.studyDate ? formatDate(dicomDateToDate(record.studyDate), 'yyyy-MM-dd', dateMessages, true) : "Not available"}</RecordDescription>
      <RecordDescription><b>Institution:</b> {record.institutionName}</RecordDescription>
      <RecordDescription small><b>Study UID:</b> {record.studyUID}</RecordDescription>
    </div>
    <RecordStatusContainer>
      <div><b>{record.status}</b></div>
      <ProgressBar progress={record.progress} failed={record.status === RecordStatus.Failed} completed={record.status === RecordStatus.Uploaded}/>
      <UploadStatus failed={record.status === RecordStatus.Failed}>
        <div>
          {
            (
              record.status === RecordStatus.Failed
              && <a className="link" css="margin-left:0.25rem" onClick={openLog}>{record.fileProgress.failed}/{record.fileProgress.total} files failed</a>
            )
            || (
              record.status === RecordStatus.Uploaded
              && <a className="link" css="margin-left:0.25rem" onClick={openLog}>{record.fileProgress.total}/{record.fileProgress.total} files uploaded</a>
            )
            ||
             <a className="link" css="margin-left:0.25rem" onClick={openLog}>{record.fileProgress.uploaded}/{record.fileProgress.total} files uploaded</a>
          }
        </div>
        <div>
          {record.status === RecordStatus.Failed && <a className="link" onClick={() => doAction(UploaderAction.Retry,record)}>Retry</a>}
          {record.status === RecordStatus.Waiting && <a className="link" onClick={() => doAction(UploaderAction.Delete,record)}>Cancel</a>}

          {record.status === RecordStatus.Uploading && <a className="link" onClick={() => doAction(UploaderAction.Pause,record)}>Pause</a>}
          {record.status === RecordStatus.Paused && <a className="link" onClick={() => doAction(UploaderAction.Retry,record)}>Resume</a>}
        </div>
      </UploadStatus>
    </RecordStatusContainer>
    {canceling.isOpen && <RemoveConfirmation>
      <div css="margin-bottom:auto;"><b>Do you want to stop the remaning uploads and remove this study from the upload list?</b></div>
      <div css="text-align:right;margin-top:0.5rem;">
        <Button outline onClick={canceling.close}>Cancel</Button>
        <Button alert onClick={() => doAction(UploaderAction.Delete,record)}>Remove</Button>
      </div>
    </RemoveConfirmation>}
  </RecordItemStyled>
}